import { useEffect } from 'react';

/**
 * OutSide 클릭 감지
 *
 * @export
 * @param {*} ref
 * @param {*} handler
 */
// eslint-disable-next-line
export function useOnClickOutside(ref: any, handler: any) {
  useEffect(
    () => {
      const listener = (event: MouseEvent | TouchEvent) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      return (): void => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    },
    [ref, handler],
  );
}
